
import expenses from '../api/expenses'

export const state = {
  expenses: [],
  expense_pagination_data: {},
  expense: '',
  available_approved_expenses: [],
  approve_expenses: []
}

export const getters = {
  expenses: state => state.expenses,
  expense_pagination_data: state => state.expense_pagination_data,
  expense: state => state.expense,
  available_approved_expenses: state => state.available_approved_expenses,
  approve_expenses: state => state.approve_expenses
}

export const mutations = {
  ADD_EXPENSE (state, data) {
    state.expenses.push(data)
  },
  SET_EXPENSES (state, data) {
    state.expenses = data
  },
  SET_EXPENSE_PAGINATION (state, data) {
    state.expense_pagination_data = data
  },
  SHOW_EXPENSE (state, data) {
    state.expense = data
  },
  SET_AVAILABLE_APPROVED_EXPENSES (state, data) {
    state.available_approved_expenses = data
  },
  SET_APPROVE_EXPENSES (state, data) {
    state.approve_expenses = data
  }
}

export const actions = {
  GET_EXPENSES ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      expenses.get(data).then(response => {
        commit('SET_EXPENSES', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_EXPENSE_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_EXPENSE ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      expenses.create(data).then(response => {
        commit('ADD_EXPENSE', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_EXPENSE ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      expenses.show(id).then(response => {
        commit('SHOW_EXPENSE', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_EXPENSE ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      expenses.update(data, state.expense.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_EXPENSE ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      expenses.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  GET_AVAILABLE_APPROVED_EXPENSES ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      expenses.availableApprovedExpenses(data).then(response => {
        commit('SET_AVAILABLE_APPROVED_EXPENSES', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  GET_APPROVE_EXPENSES ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      expenses.getApproveExpenses(data).then(response => {
        commit('SET_APPROVE_EXPENSES', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_EXPENSE_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/expenses.js